import type { CreateBranchTarget } from './types.tsx';

const buildVsCodeUrl = (issueKey: string, host: string): string => {
	const issueKeyQs = encodeURIComponent(issueKey);
	const hostQs = encodeURIComponent(host);
	return `vscode://atlassian.atlascode/startWorkOnJira?key=${issueKeyQs}&site=${hostQs}&source=jira`;
};

export const createVsCodeBranchTarget = (
	productName: string,
	issueKey: string,
	host: string,
): CreateBranchTarget => ({
	name: productName,
	url: buildVsCodeUrl(issueKey, host),
	baseUrl: null,
	applicationLinkId: null,
	applicationType: 'vscode.atlascode',
	iconClass: null,
	iconUrl:
		'https://atlassian.gallerycdn.vsassets.io/extensions/atlassian/atlascode/3.9.11/1749169574887/Microsoft.VisualStudio.Services.Icons.Small',
});
